// extracted by mini-css-extract-plugin
export default {"button":"tan_view_button__DxBMs"};